import {version} from '../../package.json';

export const shouldReleaseFeature = (featureFlagVersion?: unknown) => {
  if (typeof featureFlagVersion === 'boolean') {
    return featureFlagVersion;
  }
  // if we delete feature flag after some time, it should work without this feature flag
  if (!featureFlagVersion) return true;
  if (typeof featureFlagVersion !== 'string') {
    return true;
  }
  const [
    packageMajorVersion = 0,
    packageMinorVersion = 0,
    packagePatchVersion = 0,
  ] = version.split('.').map(Number);
  const [
    featureFlagMajorVersion = 0,
    featureFlagMinorVersion = 0,
    featureFlagPatchVersion = 0,
  ] = featureFlagVersion.split('.').map(Number);
  if (packageMajorVersion > featureFlagMajorVersion) {
    return true;
  } else if (
    packageMajorVersion === featureFlagMajorVersion &&
    packageMinorVersion > featureFlagMinorVersion
  ) {
    return true;
  } else if (
    packageMajorVersion === featureFlagMajorVersion &&
    packageMinorVersion === featureFlagMinorVersion &&
    packagePatchVersion >= featureFlagPatchVersion
  ) {
    return true;
  }
  return false;
};
